import { fg } from '@atlaskit/platform-feature-flags/fg';

/**
 * The streaming grey-out dims the source content while the AI response is
 * applied. Sessions that write the response in one go leave it dimmed with
 * nothing replacing it, so the affordance misrepresents what is happening.
 */
export const isStreamingGreyoutSuppressed = (): boolean =>
	fg('platform_editor_ai_suppress_streaming_greyout');
